import React from "react";
import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import CustomerConsent from "../src/Modules/customer-consent/CustomerConsent";
import Home from "../src/Modules/Home/Home";
import Agreement from "./Modules/agreement/Agreement";
import { ViewInspection } from "./Modules/view-inspection/ViewInspection";
import FinalInspectionInventory from "./Modules/Final-inspection/FinalInspectionInventory";
import CustomerConsentV2Page from "./Modules/customer-consent-v2/CustomerConsentV2Page";
import FeedbackPage from "./Modules/feedback/FeedbackPage";
import ServiceFeedback from "./Modules/service-feedback/ServiceFeedback";
import ServiceShareEstimate from "./Modules/service-share-estimare/ServiceShareEstimate";

// import CustomerConsentV2Page from "./Modules/customer-consent-v2/CustomerConsentV2Page";
// import CustomerConsentV2Page from "./Modules/customer-consent-v2/CustomerConsentV2Page.updated";

function App() {
  return (
    <BrowserRouter>
      <ToastContainer />
      <Routes>
        <Route path="/approval-v2" element={<CustomerConsent />} />
        <Route path="/approval" element={<CustomerConsentV2Page />} />
        <Route path="/agreement" element={<Agreement />} />
        <Route path="/view-inspection" element={<ViewInspection />} />
        <Route path="/feedback/:LeadId" element={<FeedbackPage />} />
        <Route path="/service-feedback/:ticketNo" element={<ServiceFeedback />} />
        <Route
          path="/final-inventory-report"
          element={<FinalInspectionInventory />}
        />
        <Route
          path="/service-share-estimate/:jobCardNo"
          element={<ServiceShareEstimate />}
        />
        <Route path="*" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
